import { REPORT_TYPE_IDS } from "../../../store/constants";
import AnnualDataQuality from "./AnnualDataQuality";

const AnnualBranchBenchmark = () => (
  <AnnualDataQuality
    reportTypeId={REPORT_TYPE_IDS.annual_branch_location_performance_benchmark}
    title="Annual Branch/Location Performance Benchmark"
    description="Annual branch benchmark for demand, outcomes, wait/service percentiles, workload, and confidence."
    emptyDataMessage="Annual Branch Benchmark data is empty for the selected year."
    searchPrompt="Update filters and hit Search to retrieve annual Branch Benchmark data."
  />
);

export default AnnualBranchBenchmark;
